import { SignalTypeEnum as SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

/** @deprecated use `SignalType` / `signalTypeMap` from "app/pages/sales-intelligence/domain/signals/types/signal" */
export default SignalType;
